import { ThreatsService, ThreatsProvider, HttpService } from "@sportal/api";

export const makeThreatsService = (
  http: HttpService,
  url: string
): ThreatsService => new ThreatsService(new ThreatsProvider(http, url));
